import { Box, useTheme } from '@mui/material';
import Localizacion from '@shared/assets/logos/Localizacion';
import ItineraryText from '@FlightsComponents/ItineraryText';

const LocalizationWithLabel = ({ label }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100px',
      }}
    >
      <Localizacion color={theme.primary} width={20} height={25} />
      <ItineraryText
        sx={{
          fontWeight: 600,
          mt: 0.5,
          textAlign: 'center',
          textTransform: 'capitalize',
        }}
      >
        {label}
      </ItineraryText>
    </Box>
  );
};

export default LocalizationWithLabel;
